export class QuoteAttachment {
  constructor(
    public readonly id: string,
    public readonly quoteId: string,
    public readonly filename: string,
    public readonly extensionType: string,
    public readonly filePath: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): QuoteAttachment {
    return new QuoteAttachment(
      json['id'],
      json['quote_id'],
      json['filename'],
      json['extension_type'],
      json['filepath'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}